import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
import type { GenerateAIResponse } from '@/types/generate-ai';
import type { MissionAIGenerateFormData } from './mission-ai-generate.schema';

interface UseGenerateMissionOptions {
  tenantId: string;
}

export const useGenerateMission = ({ tenantId }: UseGenerateMissionOptions) => {
  return useMutation<GenerateAIResponse, Error, MissionAIGenerateFormData>({
    mutationFn: async (data: MissionAIGenerateFormData) => {
      try {
        const response = await axiosInstance.post<GenerateAIResponse>(
          `${env.apiTasklistBaseUrl}/api/v1/compro/${tenantId}/ai/generate-mission`,
          data,
        );
        return response.data;
      } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to generate mission';
        throw new Error(message);
      }
    },
  });
};
